/**
 * Fetcher pure functions untuk report domain.
 *
 * Subdomain:
 *   - report/finance         → laporan keuangan (get, download xlsx)
 *   - report/income          → omzet, order count, statistik, weight, agen list, transactions
 *   - report/user            → laporan user/agen/member statistik
 *
 * Download/export return blob (untuk js-file-download di komponen).
 */
import http from "@/config/http";

/* ============================================================
 * Report Finance
 * ============================================================ */

export async function fetchReportFinance(params = {}) {
  const { data } = await http.get("/api/v1/report/finance/get-report", {
    params,
    timeout: 5 * 60 * 1000,
  });
  return data;
}

export async function downloadReportFinance(params = {}, config = {}) {
  const { data } = await http.get("/api/v1/report/finance/download-report", {
    params,
    responseType: "blob",
    timeout: 10 * 60 * 1000,
    ...config,
  });
  return data;
}

/* ============================================================
 * Report Income (Internasional)
 * ============================================================ */

export async function fetchOmzet(params = {}) {
  const { data } = await http.get("/api/v1/report/income/get-omzet", {
    params,
  });
  return data;
}

export async function fetchOmzetReal(params = {}) {
  const { data } = await http.get("/api/v1/report/income/get-omzet-real", {
    params,
  });
  return data;
}

export async function fetchStatisticOmzet(params = {}) {
  const { data } = await http.get(
    "/api/v1/report/income/get-statistics-omzet",
    { params }
  );
  return data;
}

export async function fetchOrderCount(params = {}) {
  const { data } = await http.get("/api/v1/report/income/get-order", {
    params,
  });
  return data;
}

export async function fetchOrderStatistics(params = {}) {
  const { data } = await http.get("/api/v1/report/income/get-order-statistics", {
    params,
  });
  return data;
}

export async function fetchWeight(params = {}) {
  const { data } = await http.get("/api/v1/report/income/get-weight", {
    params,
  });
  return data;
}

export async function fetchOrderAgenList(params = {}) {
  const { data } = await http.get(
    "/api/v1/report/income/get-omzet-agen-list",
    { params }
  );
  return data;
}

export async function fetchOrderTransactions(params = {}) {
  const { data } = await http.get(
    "/api/v1/report/income/order-transactions",
    { params }
  );
  return data;
}

export async function fetchOrderAgenTransactions(params = {}) {
  const { data } = await http.get(
    "/api/v1/report/income/order-agen-transactions",
    { params }
  );
  return data;
}

/* ============================================================
 * Report Income (Domestik)
 * ============================================================ */

export async function fetchOmzetDomestik(params = {}) {
  const { data } = await http.get("/api/v1/report/income/get-omzet-domestik", {
    params,
  });
  return data;
}

export async function fetchOrderDomestik(params = {}) {
  const { data } = await http.get("/api/v1/report/income/get-order-domestik", {
    params,
  });
  return data;
}

export async function fetchDomestikStatistics(params = {}) {
  const { data } = await http.get(
    "/api/v1/report/income/get-domestik-statistics",
    { params }
  );
  return data;
}

export async function fetchWeightDomestik(params = {}) {
  const { data } = await http.get(
    "/api/v1/report/income/get-weight-domestik",
    { params }
  );
  return data;
}

export async function fetchOrderTransactionsDomestik(params = {}) {
  const { data } = await http.get(
    "/api/v1/report/income/order-transactions-domestik",
    { params }
  );
  return data;
}

/* ============================================================
 * Report User
 * ============================================================ */

export async function fetchReportAgen(params = {}) {
  const { data } = await http.get("/api/v1/report/user/get-agen", { params });
  return data;
}

export async function fetchReportAgenStatistics(params = {}) {
  const { data } = await http.get("/api/v1/report/user/get-agen-statistics", {
    params,
  });
  return data;
}

export async function fetchReportMember(params = {}) {
  const { data } = await http.get("/api/v1/report/user/get-member", { params });
  return data;
}

export async function fetchReportMemberStatistics(params = {}) {
  const { data } = await http.get("/api/v1/report/user/get-member-statistics", {
    params,
  });
  return data;
}

export async function fetchReportUser(params = {}) {
  const { data } = await http.get("/api/v1/report/user/get-user", { params });
  return data;
}
